import styled from 'styled-components'
import colorConfig from '../../colorConfig';

const ArticleArea = styled.div`
   font-size: 20px;
   font-weight: 400;
   line-height: 33.6px;
   margin-bottom: 0px;
   font-family: "RM Neue", "sans-serif";
   color: ${colorConfig.tabellrad_tekst} !important;

   h1, h2, h3, h4, h5, h6{
    font-weight: 400;    
    margin-bottom: 10px;
    margin-top: 16px;
    font-size: 30px;
    color: black !important;
    }

    p{
        font-size: 20px;
        margin-top: 0px;
        margin-bottom: 10px;
    }
`

const ContentArea = styled.div`
    padding: 37px 50px 15px 50px;     
    font-weight: 300;

    @media (max-width: 768px) {
        padding: 37px 16px 15px 16px;
    }
`
export {ContentArea, ArticleArea}